/**
 * Notifications éphémères affichées en toast : une notification en remplace
 * toujours une précédente et réarme le minuteur de masquage.
 */
import { defineStore } from "pinia";
import { ref } from "vue";

import { createId } from "@/lib/id";

export type Tone = "success" | "error";

export interface Notification {
  id: string;
  message: string;
  tone: Tone;
}

const AUTO_DISMISS_MS = 3500;

export const useNotificationsStore = defineStore("notifications", () => {
  const current = ref<Notification | null>(null);
  let dismissTimer: ReturnType<typeof setTimeout> | undefined;

  function clearTimer(): void {
    if (dismissTimer !== undefined) {
      clearTimeout(dismissTimer);
      dismissTimer = undefined;
    }
  }

  function notify(message: string, tone: Tone = "success"): void {
    clearTimer();
    current.value = { id: createId("notification"), message, tone };
    dismissTimer = setTimeout(() => {
      current.value = null;
      dismissTimer = undefined;
    }, AUTO_DISMISS_MS);
  }

  function dismiss(): void {
    clearTimer();
    current.value = null;
  }

  return { current, notify, dismiss };
});
